import React, { useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { Toaster } from 'sonner';
import { Outlet } from 'react-router-dom';

export default function MainLayout() {
  // Inicializar el estado del sidebar basado en el tamaño de la pantalla
  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(() => {
    // En la carga inicial, verificar si es un dispositivo móvil o tablet
    return window.innerWidth < 1024; // Colapsar por defecto si es menor a 1024px (tablet o móvil)
  });

  // Actualizar el estado del sidebar cuando cambia el tamaño de la ventana
  useEffect(() => {
    const handleResize = () => {
      // Si es un dispositivo móvil o tablet, colapsar el sidebar
      if (window.innerWidth < 1024) {
        setIsSidebarCollapsed(true);
      }
    };

    // Agregar event listener para el resize
    window.addEventListener('resize', handleResize);
    
    // Limpiar el event listener cuando el componente se desmonta
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="relative flex h-screen bg-background text-foreground overflow-hidden">
      {/* Luz ambiental de fondo (violeta/azul/cian) */}
      <div aria-hidden className="pointer-events-none fixed inset-0 z-0">
        <div className="absolute -top-48 -left-40 w-[620px] h-[620px] rounded-full bg-violet-600 opacity-[0.07] blur-[120px]" />
        <div className="absolute top-1/3 -right-48 w-[560px] h-[560px] rounded-full bg-blue-600 opacity-[0.06] blur-[120px]" />
        <div className="absolute -bottom-40 left-1/3 w-[520px] h-[420px] rounded-full bg-cyan-500 opacity-[0.04] blur-[120px]" />
      </div>

      <div className="relative z-10 flex flex-1 min-w-0">
        <Sidebar isCollapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar} />
        <div className="flex-1 flex flex-col overflow-hidden">
          <Header toggleSidebar={toggleSidebar} isSidebarCollapsed={isSidebarCollapsed} />
          <main className="flex-1 p-3 sm:p-6 lg:p-8 overflow-auto"><Outlet /></main>
        </div>
      </div>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

